import React from 'react';
import { Countdown } from './Countdown';

// 23:54:19
const START_SECONDS = 23 * 3600 + 54 * 60 + 19;
export function UrgencyBlock() {
  return <section className="w-full bg-blood-900 px-4 py-8 sm:px-6 sm:py-10" data-id="element-193" data-mp="3iqvdkt33vrb2">
      <div className="mx-auto max-w-2xl text-center" data-id="element-194" data-mp="3dy2asar76t1m">
        <h2 className="text-sm font-extrabold uppercase tracking-wide text-white sm:text-lg" data-id="element-195" data-mp="39xrspzq4sc6e">
          ⏰ Precio de lanzamiento — cierra en:
        </h2>

        <div className="mt-4" data-id="element-196" data-mp="3509v35hkdjdp">
          <Countdown startSeconds={START_SECONDS} data-id="element-197" data-mp="34wc9md7ikfqn" />
        </div>

        <p className="mt-4 text-[13px] font-semibold text-neutral-300 sm:text-base" data-id="element-198" data-mp="2zy0ylz5hfz6u">
          ⚠️ Después sube{' '}
          <span className="font-extrabold text-blood-500" data-id="element-199" data-mp="2v2lmbbn4ibcj">$10.000 ARS</span>. No
          vuelve.
        </p>

        <div className="mt-6 rounded-xl border border-red-900/60 bg-black/40 p-4" data-id="element-200" data-mp="2r1a59uibeyfy">
          <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1 text-left" data-id="element-201" data-mp="t8curuerd17c">
            <span className="text-[13px] font-bold text-blood-500" data-id="element-202" data-mp="p8c51dm7l3kz">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-[13px] font-bold text-neutral-300" data-id="element-203" data-mp="19wgqb6262ygu">
              Quedan pocos
            </span>
          </div>
          <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-neutral-700" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento ya tomados" data-id="element-204" data-mp="vy0ifbskj1x4">
            <div className="h-full w-[72%] rounded-full bg-gradient-to-r from-orange-500 to-red-600" data-id="element-205" data-mp="1slwr7uhrksxs" />
          </div>
          <p className="mt-2.5 text-left text-[11px] text-neutral-400 sm:text-xs" data-id="element-206" data-mp="1evbfqqun3l9x">
            72% de los cupos al precio de lanzamiento ya tomados.
          </p>
        </div>
      </div>
    </section>;
}